import i18n from '@/i18n';
export default [
  // 策略管理
  {
    path: '/advancedService/list',
    name: 'advancedService',
    component:()=>import("@/views/advancedService"),
    meta: {
      requireAuth: false,
      active: 'advancedService/list',
      noAuth: false,
      bread: [
        { name: i18n.t('HT.menu.advancedService'), icon: 'ux_icon_authority' },
        { name: i18n.t('HT.menu.advancedService.strategy') }
      ]
    }
  },
  {
    path: '/advancedService/detail',
    name: 'advancedServiceDetail',
    component:()=>import("@/views/advancedService/detail"),
    meta: {
      requireAuth: false,
      active: 'advancedService/list',
      noAuth: false,
      bread: [
        { name: i18n.t('HT.menu.advancedService') },
        { name: i18n.t('HT.menu.advancedService.strategy'), url: '/advancedService/list'},
        { name: i18n.t('HT.menu.advancedService.strategyDetail') },
      ]
    }
  },
  {
    path: '/advancedService/mctype',
    name: 'advancedServiceMctype',
    component:()=>import("@/views/advancedService/mctype"),
    meta: {
      requireAuth: false,
      active: 'advancedService/mctype',//这里的active是path，并且不用最前面的/
      noAuth: false,
      bread: [
        { name: i18n.t('HT.menu.advancedService')},
        { name: i18n.t('HT.menu.advancedService.mctype') }
      ]
    }
  },
  {
    path: '/advancedService/service',
    name: 'advancedServiceService',
    component:()=>import("@/views/advancedService/service"),
    meta: {
      requireAuth: false,
      active: 'advancedService/service',
      noAuth: false,
      bread: [
        { name: i18n.t('HT.menu.advancedService')},
        { name: i18n.t('HT.menu.advancedService.service') }
      ]
    }
  },
  {
    path: '/advancedService/log',
    name: 'advancedServiceLog',
    component:()=>import("@/views/advancedService/log"),
    meta: {
      requireAuth: false,
      noAuth: false,
      bread: [
        { name: i18n.t('HT.menu.advancedService')},
        { name: i18n.t('HT.menu.advancedService.log') }
      ]
    }
  },
  {
    path: '/advancedService/device',
    name: 'advancedServiceDevice',
    component:()=>import("@/views/advancedService/device"),
    meta: {
      requireAuth: false,
      active: 'advancedService/device',
      noAuth: false,
      bread: [
        { name: i18n.t('HT.menu.advancedService'), icon: 'ux_icon_authority' },
        { name: i18n.t('HT.menu.advancedService.device') }
      ]
    }
  },
  {
    path: '/advancedService/device/detail',
    name: 'advancedServiceDeviceDetail',
    component:()=>import("@/views/advancedService/device/detail"),
    meta: {
      requireAuth: false,
      active: 'advancedService/device',
      noAuth: false,
      bread: [
        { name: i18n.t('HT.menu.advancedService') },
        { name: i18n.t('HT.menu.advancedService.device'), url: '/advancedService/device'},
        { name: i18n.t('HT.common.detail') },
      ]
    }
  },
  {
    path: '/advancedService/user',
    name: 'advancedServiceUser',
    component:()=>import("@/views/advancedService/user"),
    meta: {
      requireAuth: false,
      active: 'advancedService/user',
      noAuth: false,
      bread: [
        { name: i18n.t('HT.menu.advancedService'), icon: 'ux_icon_authority' },
        { name: i18n.t('HT.menu.advancedService.user') }
      ]
    }
  },
  {
    path: '/advancedService/user/detail',
    name: 'advancedServiceUserDetail',
    component:()=>import("@/views/advancedService/user/detail"),
    meta: {
      requireAuth: false,
      active: 'advancedService/user',
      noAuth: false,
      bread: [
        { name: i18n.t('HT.menu.advancedService') },
        { name: i18n.t('HT.menu.advancedService.user'), url: '/advancedService/user'},
        { name: i18n.t('HT.common.detail') },
      ]
    }
  },
];
